export default "__VITE_ASSET__CTPDNw5A__"